import { Outlet, useParams } from "react-router-dom";
import PromotionsPage from "../../../modules/promotion/PromotionsPage";

const Tab6 = ({ routeBase = "/customer/promotions" }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PromotionsPage routeBase={routeBase} />;
};

export default Tab6;

